@if (formMode()) {
  <section class="manual-validation-card" aria-labelledby="manual-validation-title">
    <h3 id="manual-validation-title">Datos del comprobante</h3>
    @if (submitted()) {
      <p class="manual-validation-success" role="status">Datos enviados.</p>
    } @else {
      <form #manualForm="ngForm" (ngSubmit)="submit()">
        <label>
          <span>Fecha de operación <span class="required-indicator" aria-hidden="true">*</span></span>
          <input
            type="date"
            name="operationDate"
            required
            aria-required="true"
            aria-describedby="operation-date-hint"
            [ngModel]="operationDate()"
            (ngModelChange)="operationDate.set($event)"
          />
          <span class="field-hint" id="operation-date-hint">Selecciona la fecha. Ej.: 07/10/2026.</span>
        </label>
        <label>
          <span>Monto <span class="required-indicator" aria-hidden="true">*</span></span>
          <input
            type="text"
            name="amount"
            inputmode="decimal"
            placeholder="Solo números y punto decimal"
            pattern="[0-9]{1,6}(\.[0-9]{1,2})?"
            maxlength="9"
            required
            aria-required="true"
            aria-describedby="amount-hint"
            [ngModel]="amount()"
            (ngModelChange)="onAmountChange($event)"
            (beforeinput)="onAmountBeforeInput($event)"
            (paste)="onAmountPaste($event)"
          />
          <span class="field-hint" id="amount-hint">Hasta 6 enteros y 2 decimales. Ej.: 1250.50.</span>
        </label>
        <label>
          <span>Número de operación <span class="required-indicator" aria-hidden="true">*</span></span>
          <input
            type="text"
            name="operationNumber"
            inputmode="numeric"
            placeholder="8 dígitos numéricos"
            pattern="[0-9]{8}"
            minlength="8"
            maxlength="8"
            required
            aria-required="true"
            aria-describedby="operation-number-hint"
            [ngModel]="operationNumber()"
            (ngModelChange)="onOperationNumberChange($event)"
            (beforeinput)="onOperationNumberBeforeInput($event)"
            (paste)="onOperationNumberPaste($event)"
          />
          <span class="field-hint" id="operation-number-hint">Exactamente 8 dígitos, sin letras. Ej.: 01234567.</span>
        </label>
        @if (submitError()) {
          <p class="manual-validation-error" role="alert">
            No se pudieron enviar los datos. Inténtalo nuevamente.
          </p>
        }
        <button type="submit" [disabled]="!manualForm.valid || !canSubmit()">
          {{ submitting() ? 'Enviando…' : 'Enviar datos' }}
        </button>
      </form>
    }
  </section>
} @else {
  <div class="payment-result__state payment-result__state--generic">
    @if (messageText().trim()) {
      <p class="manual-validation-prompt">{{ messageText() }}</p>
    } @else {
      <p class="manual-validation-prompt">
        Para continuar con la validación de tu pago da click en
        <strong>Validar manualmente</strong>
      </p>
    }
  </div>
  @if (message().paymentRetryStatus === 'AVAILABLE' && !requestSent()) {
      <button
        type="button"
        class="manual-validation-trigger"
        (click)="requestManualReviewForm()"
      >Validar manualmente</button>
  }
}
